<template>
  <a-modal
    title="分类编辑"
    @cancel="handleChangeSubjectCancel"
    @ok="handleOk"
    :visible="changeVisible"
  >
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="分类选择">
        <a-select placeholder="请选择分类" v-model="newSubjectId" style="width: 70%">
          <a-select-option
            v-for="(subject, index) in subjects"
            :value="subject.subjectId"
            :key="index"
          >
            {{ subject.subjectName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateRSubjectItemApi } from '@/api/TopicCrawl/CollectList'
import { querySubjectListApi } from '@/api/TopicCrawl/WiliType'

export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      uploadLoading: false,
      subjects: [],
      newSubjectId: null
    }
  },
  props: {
    subjectId: Number,
    changeVisible: Boolean,
    subjectContentId: String
  },
  created: function () {
    this.newSubjectId = this.subjectId
    this.querySubjectList()
  },
  methods: {
    handleClose() {
      this.$emit('onSubmitSuccess')
    },

    handleCancle() {
      this.$emit('onClose')
    },
    handleSubmit() {},
    async querySubjectList() {
      let query = {
        pn: 1,
        pageSize: 100,
        type: 'wiki'
      }
      const res = await querySubjectListApi(query)
      let { code, msg, data, extra } = res
      this.subjects = data
    },
    handleChangeSubjectCancel() {
      this.$emit('update:changeVisible', false)
    },
    async handleOk() {
      if (this.subjectId == this.newSubjectId) {
        this.$emit('update:changeVisible', false)
        return
      }
      let params = {
        subjectContentId: this.subjectContentId,
        oldSubjectId: this.subjectId,
        newSubjectId: this.newSubjectId
      }
      let res = await updateRSubjectItemApi(params)
      let { code } = res
      if (code == '200') {
        this.$message.success('修改成功')
        this.$emit('success')
        this.$emit('update:changeVisible', false)
      } else {
        this.$message.success('修改失败')
      }
    }
  },
  watch: {
    changeVisible: {
      handler() {
        if (this.changeVisible == true) {
          this.newSubjectId = this.subjectId
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.ant-upload-text {
  color: #9999;
}
</style>
